/**
 * scanDocument.js — Simplified single-item scan confirmation dialog.
 *
 * CHANGES:
 * 1. Uses new /api/avia-scan/scan/ and /api/fura-scan/scan/ endpoints
 * 2. No more combined-tracking endpoint
 * 3. Simpler, cleaner logic
 */

import {connect} from "react-redux";
import React, {useEffect, useState} from "react";
import Dialog from '@mui/material/Dialog';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Button from "@mui/material/Button";
import {getAlLThis, messageReset} from "../store/documents";
import {Slide, toast} from "react-toastify";
import audio_finish from '../finish.mp3'
import {getAllVerifyResponse} from "../store/logIn";
import axios from 'axios';

const API_BASE = 'https://fx.softmakon.uz/api';

function ScanDocument(props) {
    let finish = new Audio(audio_finish)
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setLoading(false);
        setTimeout(() => {
            props.setOpen(false);
            props.setOpenItem(false);
        }, 100);
    };

    /**
     * Get the correct endpoint based on type.
     */
    const getScanUrl = (type) => {
        if (type === 'avia')          return `${API_BASE}/combined-tracking/scan/`;  // AviaTrackCode (eski model)
        if (type === 'fura')          return `${API_BASE}/fura-scan/scan/`;
        if (type === 'avia_tracking') return `${API_BASE}/avia-scan/scan/`;           // AviaTracking (yangi model)
        return null;
    };

    async function toDelete() {
        setLoading(true);

        try {
            const trackType = props.openItem['type'];
            const scanUrl = getScanUrl(trackType);

            if (!scanUrl) {
                toast.error("Noto'g'ri trek turi!", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: "colored",
                    transition: Slide,
                });
                return;
            }

            const response = await axios.patch(scanUrl, {
                serial_number: props.openItem['part'],
                code: props.openItem['code'],
                track_code: props.openItem['track_code'],
            });

            if (response.status === 200) {
                finish.play();
                toast.success("Muvaffaqiyatli saqlandi!", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: "colored",
                    transition: Slide,
                });

                // Scanlangan trek kodni yuqoriga bildirish (backEndsiz, faqat frontend)
                if (props.onScanned && props.openItem?.track_code) {
                    props.onScanned(props.openItem.track_code);
                }

                props.setOpen(false);
                props.setOpenItem(false);
            }
        } catch (error) {
            console.error('Error scanning document:', error);
            toast.error("Xatolik yuz berdi!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: "colored",
                transition: Slide,
            });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (props.open) {
            setOpen(props.open)
        }
    }, [props])

    useEffect(() => {
        if (props.message === true) {
            finish.play()
            toast.success("Muvaffaqiyatli saqlandi!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: "colored",
                transition: Slide,
            })
            props.messageReset()
            props.setOpen(false)
            props.setOpenItem(false)
        }
    }, [props.message]);

    return <div>
        <Dialog
            open={open}
            className={"scanNow"}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <div className={'delete-modal'}>
                <div className="icon">
                    <HighlightOffIcon color={'error'}/>
                </div>
                <h2>{"Tasdiqlash"}</h2>
                <p>{"Ha tugmasini bosish orqali ushbu buyurtmani joylashgan joyi avtomatik tarzda o'zgaradi va qayta o'zgartira olmaysiz"}</p>
                {props.openItem?.type && (
                    <p>
                        <strong>Turi: </strong>
                        <span className={`badge ${
                            props.openItem.type === 'avia' ? 'bg-primary' :
                                props.openItem.type === 'avia_tracking' ? 'bg-warning text-dark' :
                                    'bg-success'
                        }`}>
                            {props.openItem.type === 'avia' ? 'Avia' :
                                props.openItem.type === 'avia_tracking' ? 'Avia Tracking' :
                                    'Fura'}
                        </span>
                    </p>
                )}
                <div className="buttons">
                    <Button variant="contained" className={'cancel-btn'} onClick={handleClose} disabled={loading}>
                        {"Yo'q ortga qaytish"}
                    </Button>
                    <Button variant="contained" className={'delete-btn'} onClick={toDelete} disabled={loading}>
                        {loading ? "O'zgartirilmoqda..." : "Ha o'zgartirish"}
                    </Button>
                </div>
            </div>
        </Dialog>
    </div>
}

export default connect(props => props.documents, {
    getAllVerifyResponse,
    getAlLThis,
    messageReset
})(ScanDocument)